var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"empty-list"},[_c('img',{attrs:{"src":require(`../assets/images/empty-icons/${_vm.imgFileName}`),"alt":"","role":"presentation","width":"160","height":"160"}}),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.action))])])
}
var staticRenderFns = []

export { render, staticRenderFns }